(() => {
  if (!customElements.get('cr-product-whatsapp')) {
    customElements.define('cr-product-whatsapp', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.addEventListener('click', (event) => {
          const link = event.target.closest('a[data-cr-wa-main], a[data-cr-wa-question]');
          if (link && this.contains(link)) this.updateLink(link);
        }, { signal });
        document.addEventListener('variant:update', (event) => {
          if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
          const variant = event.detail?.resource;
          if (variant?.id) {
            this.dataset.variantId = String(variant.id);
            this.dataset.variantTitle = variant.title || '';
          }
          this.updateAll();
        }, { signal });
        this.updateAll();
      }
      disconnectedCallback() { this.controller?.abort(); }
      purchaseForm() {
        const section = document.getElementById('shopify-section-' + this.dataset.sectionId);
        const components = section?.querySelectorAll('product-form-component') || [];
        return [...components].find(node => node.dataset.productId === this.dataset.productId)?.querySelector('form');
      }
      message(question) {
        const form = this.purchaseForm();
        const variantId = form?.querySelector('[name="id"]')?.value || this.dataset.variantId;
        const url = new URL(this.dataset.productUrl);
        if (/^\d+$/.test(variantId || '')) url.searchParams.set('variant', variantId);
        const lines = ['Hola Crealis, estoy mirando ' + this.dataset.productTitle + '.', url.href];
        const variantTitle = this.dataset.variantTitle;
        // Never attach a stale title when a picker changed the id before its update event.
        if (variantId === this.dataset.variantId && variantTitle && variantTitle !== 'Default Title') lines.push('Opción: ' + variantTitle);
        const quantity = form?.querySelector('[name="quantity"]')?.value;
        if (/^\d+$/.test(quantity || '') && Number(quantity) > 0) lines.push('Cantidad seleccionada: ' + quantity);
        if (form) {
          const properties = new Map();
          for (const field of form.querySelectorAll('[name^="properties["]')) {
            const match = field.name.match(/^properties\[([^\]]+)\]$/);
            if (!match || match[1].startsWith('_') || field.disabled || field.type === 'file' || (['radio','checkbox'].includes(field.type) && !field.checked)) continue;
            const value = String(field.value || '').trim().slice(0, 120);
            if (value && properties.size < 20) properties.set(match[1], value);
          }
          for (const [name, value] of properties) lines.push(name + ': ' + value);
        }
        lines.push('', question);
        return lines.join('\n');
      }
      updateLink(link) {
        link.href = 'https://wa.me/' + this.dataset.phone + '?text=' + encodeURIComponent(this.message(link.dataset.crWaQuestion || this.dataset.defaultQuestion));
      }
      updateAll() { this.querySelectorAll('a[data-cr-wa-main], a[data-cr-wa-question]').forEach(link => this.updateLink(link)); }
    });
  }
  if (!customElements.get('cr-home-contact')) {
    customElements.define('cr-home-contact', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('change', () => this.update(), { signal: this.controller.signal });
        this.update();
      }
      disconnectedCallback() { this.controller?.abort(); }
      update() {
        const topic = this.querySelector('input:checked')?.value || 'un producto';
        const message = 'Hola Crealis, vengo desde crealis.cl y quiero consultar por ' + topic + '.';
        const preview = this.querySelector('[data-cr-home-preview]');
        const link = this.querySelector('[data-cr-home-wa]');
        if (preview) preview.textContent = message;
        if (link) link.href = 'https://wa.me/' + this.dataset.phone + '?text=' + encodeURIComponent(message);
      }
    });
  }
})();

